import { render } from "./ChatBotAiAssistantEditorCmp.vue?vue&type=template&id=642762c2"
import script from "./ChatBotAiAssistantEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotAiAssistantEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__